
import gsap from 'gsap'
import scrollTrigger from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const duration = .2
    const ease = "power2.inOut"


    const heroImage = document.querySelector('.home-hero .desktop')
    const heroTitle = document.querySelector('.home-hero h1')
    const heroCopy = document.querySelector('.home-hero--content-description')
    const heroButtons = document.querySelector('.home-hero--links')

    if(!heroTitle) {
        return;
    }

    let tl = gsap.timeline()
    // Animate image
    tl.to(heroImage, { opacity: 1, translateY: 0,  ease })

    // Animate h1
    Array.from(heroTitle.querySelectorAll('span')).forEach((line, i) => {
        tl.to(line, { opacity: 1, translateY: 0,  ease }, `-=.4`)
    })

    // Animate copy
    tl.to(heroCopy, { opacity: 1, ease, duration }, `-=.25`)

    // Animate buttons
    Array.from(heroButtons.querySelectorAll('a')).forEach((link, i) => {
        tl.to(link, { opacity: 1, translateX: 0,  ease }, `-=.4`)
    })

}

